import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import WidthContainer from '../../../components/WidthContainer'
import {imageType} from '../../../utils/commonPropTypes'
import {QueriedGatsbyImage} from '../../../components/GatsbyImage'
import Markdown from '../../../components/Markdown'

const RootContainer = styled.div`
`

const WidthContainerStyled = styled(WidthContainer)`
	max-width: ${props => props.theme.smallerWidth};;
`

const Text = styled(Markdown)`
	font-size: ${props => props.theme.fontSizes.small};
	max-width: ${props => props.theme.smallerWidth};
	margin: 2.4rem auto;
`
const ImageContainer = styled(WidthContainer)`
	max-width: 48rem;
`
const Image = styled(QueriedGatsbyImage)`
	width: 100%;
`

const Caption = styled.div`
	color: ${props => props.theme.colors.grayText};
	font-size: ${props => props.theme.fontSizes.smallest};
	font-weight: ${props => props.theme.fontWeights.regular};
	margin: 0.875rem auto 0;
	text-align: center;
	font-style: italic;
`


const ArticleContent = ({className, data}) => <RootContainer className={className}>
	{data.map((one, i) => <div key={i}>
		{(!!one.image && !!one.image.image) && <ImageContainer><Image image={one.image.image}/></ImageContainer>}
		<WidthContainerStyled>
			{(!!one.image && !!one.image.caption) && <Caption>{one.image.caption}</Caption>}
			{one.textMd && <Text text={one.textMd}/>}
		</WidthContainerStyled>
	</div>)}
</RootContainer>

ArticleContent.propTypes = {
	className: PropTypes.string,
	data: PropTypes.arrayOf(PropTypes.shape({
		textMd: PropTypes.string.isRequired,
		image: PropTypes.shape({
			caption: PropTypes.string.isRequired,
			image: imageType,
		}).isRequired,
	}).isRequired).isRequired,
}

ArticleContent.defaultProps = {
	className: '',
}

export default ArticleContent
